import React from "react";

import Checkbox from "@material-ui/core/Checkbox";
import Collapse from "@material-ui/core/Collapse";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";

import MoreVertIcon from "@material-ui/icons/MoreVert";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";

export default class SelectPackageTableRow extends React.PureComponent {

  handleCheckbox = () => {
    this.props.handleSelectedShot(this.props.id);
  };

  render() {
    const cellStyle = {
      display: "inline-block",
      position: "relative",
      width: "100%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    };

    const { props } = this;
    const { selectedMenu } = props;
    const open = Boolean(selectedMenu);

    return (
      <TableBody>
        <TableRow key={props.id} hover onClick={this.handleCheckbox}>
          <TableCell padding="checkbox">
            <Checkbox checked={this.props.checked} color="primary" onClick={this.handleCheckbox} />
          </TableCell>
          <TableCell>
            <div style={cellStyle}>{props.title}</div>
          </TableCell>
          <TableCell>
            <div style={cellStyle}>{props.description}</div>
          </TableCell>
        </TableRow>
      </TableBody>
    );
  }
}
